import { ListResponseType, ResponseErrorType } from '@/types/sharedTypes';
import { getResponseError } from './apiHelpers/responseHelpers';
import { showSnackbar } from '@/components/Snackbar/Snackbar';
import { QueryParamsType } from '@/api/helpers/apiParamsHelpers';

export const showSnackbarResponseError = (apiError: ResponseErrorType) => {
  const error = getResponseError(apiError);

  showSnackbar(error, { variant: 'error' });
};

export const getListData = <T>(dataBody: ListResponseType<T>, searchParams: QueryParamsType) => {
  const dataResults = dataBody?.results;
  const dataCount = dataBody?.count;

  return {
    list: dataResults,
    hasData: !!dataResults?.length,
    totalCount: dataCount,
    hasPagination: dataCount > searchParams?.limit,
  };
};

export const getSearchListData = <T>(
  dataBody: ListResponseType<T>,
  searchParams: QueryParamsType,
  isPending: boolean
) => {
  const listData = getListData<T>(dataBody, searchParams);
  const hasData = listData?.hasData;
  const searchParamsName = searchParams?.name;

  return {
    ...listData,
    noResults: !hasData && !isPending && !searchParamsName,
    noSearchResults: !hasData && !isPending && !!searchParamsName,
  };
};

export const delay = (delayTime: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, delayTime));
};

export const copyToClipboard = async (value: string, message = 'Data successfully copied to clipboard') => {
  try {
    await window.navigator.clipboard.writeText(value);

    showSnackbar(message, { autoClose: 1000 });
  } catch (error) {
    showSnackbar('error from clipboard copy', { variant: 'error' });
  }
};
